var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCircleTelegram = function SvgCircleTelegram(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#telegram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.724 24.019c6.633 0 12.01-5.377 12.01-12.01C24.733 5.377 19.357 0 12.723 0 6.092 0 .714 5.377.714 12.01c0 6.632 5.378 12.009 12.01 12.009Z",
    fill: "url(#telegram_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14 11.879a383.546 383.546 0 0 1 7.015-3.012c3.33-1.384 4.022-1.627 4.47-1.646.094 0 .318.019.468.131.112.094.15.224.168.318.02.094.038.3.02.468-.188 1.889-.955 6.51-1.366 8.623-.169.898-.505 1.197-.823 1.235-.693.056-1.235-.468-1.908-.898-1.048-.692-1.647-1.122-2.675-1.796-1.179-.785-.412-1.216.261-1.908.169-.187 3.255-2.974 3.311-3.236 0-.037.02-.15-.056-.206-.075-.056-.168-.037-.243-.019-.112.02-1.796 1.142-5.07 3.349-.486.337-.916.486-1.309.486-.43 0-1.253-.243-1.87-.449-.749-.243-1.347-.374-1.291-.785.037-.206.337-.43.898-.655Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "telegram_svg__b",
    x1: 0.715,
    y1: 12.001,
    x2: 24.716,
    y2: 12.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clip-path", {
    id: "telegram_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.715)",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCircleTelegram);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/circle-telegram.63242efed2a85ee10bedda3d45ece853.svg";